import { useState, memo, useCallback } from 'react';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCampaignsContext } from './CampaignsProvider';
import CampaignsPlatformSelect from './CampaignsPlatformSelect';
import { useFetchCampaignsAssociationSettings } from './hooks/useFetchCampaignsAssociationSettings';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CampaignsPlatformEditModal({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  onClose,
  objectBuilderUiProps
}) {
  const {
    saveCampaign
  } = useCampaignsContext();
  const [isSaving, setIsSaving] = useState(false);
  const onSave = useCallback(() => {
    setIsSaving(true);
    saveCampaign({
      objectType,
      assetId,
      crmIdProperty
    }).then(() => {
      onClose();
      setIsSaving(false);
    }).catch(() => {
      onClose();
      setIsSaving(false);
    });
  }, [assetId, crmIdProperty, objectType, onClose, saveCampaign]);
  const {
    data: associationSettings,
    loading: associationSettingsLoading
  } = useFetchCampaignsAssociationSettings();
  if (associationSettingsLoading || !associationSettings || !associationSettings[objectType]) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "campaigns-platform-edit-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.editCampaign"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(CampaignsPlatformSelect, {
          objectType: objectType,
          assetId: assetId,
          crmIdProperty: crmIdProperty,
          save: false,
          editorSelect: false,
          objectBuilderUiProps: objectBuilderUiProps
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        use: "primary",
        onClick: onSave,
        loading: isSaving,
        "data-test-id": "campaigns-platform-edit-modal-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.saveEditCampaign"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.cancelEditCampaign"
        })
      })]
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformEditModal);